<template>
    <div id="patients-portal-form"></div>
</template>

<script>
import PatientsPortalBase from '../patientsPortalBase.vue';

export default {
    name: 'PatientsPortalClaims',
    extends: PatientsPortalBase,

    methods: {
        getActiveElement() {
            return 'PPDB_PatientSetup';
        }
    }
};
</script>
